import React, { useEffect, useRef, useState } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { checkMuhurtam } from "../lib/api";
import { findNearestCity } from "../lib/cities";
import { findByPincode } from "../lib/pincodes";
import MapPicker from "./MapPicker";

const SUITABLE_EVENTS = [
  { en: "Udyoga / Vyapara Arambham — starting a new job, opening a shop, or launching a business",
    te: "ఉద్యోగం / వ్యాపార ప్రారంభం — కొత్త ఉద్యోగం, దుకాణం లేదా వ్యాపారం ప్రారంభించడం",
    hi: "उद्योग / व्यापार आरंभ — नई नौकरी शुरू करना, दुकान खोलना या व्यापार शुरू करना",
    ta: "உத்யோக / வியாபார ஆரம்பம் — புதிய வேலை தொடங்குதல், கடை திறத்தல் அல்லது வணிகம் தொடங்குதல்",
    kn: "ಉದ್ಯೋಗ / ವ್ಯಾಪಾರ ಆರಂಭ — ಹೊಸ ಉದ್ಯೋಗ ಪ್ರಾರಂಭ, ಅಂಗಡಿ ತೆರೆಯುವುದು ಅಥವಾ ವ್ಯಾಪಾರ ಪ್ರಾರಂಭ",
    ml: "ഉദ്യോഗ / വ്യാപാര ആരംഭം — പുതിയ ജോലി ആരംഭിക്കൽ, കട തുറക്കൽ അല്ലെങ്കിൽ ബിസിനസ്സ് ആരംഭിക്കൽ" },
  { en: "Vahana Krayam — purchasing or taking delivery of a vehicle",
    te: "వాహన క్రయం — కొత్త వాహనం కొనుగోలు లేదా డెలివరీ తీసుకోవడం",
    hi: "वाहन क्रय — नया वाहन खरीदना या डिलीवरी लेना",
    ta: "வாகன க்ரயம் — புதிய வாகனம் வாங்குதல் அல்லது டெலிவரி பெறுதல்",
    kn: "ವಾಹನ ಕ್ರಯ — ಹೊಸ ವಾಹನ ಖರೀದಿ ಅಥವಾ ಡೆಲಿವರಿ ಪಡೆಯುವುದು",
    ml: "വാഹന ക്രയം — പുതിയ വാഹനം വാങ്ങൽ അല്ലെങ്കിൽ ഡെലിവറി സ്വീകരിക്കൽ" },
  { en: "Vidya Arambham — enrolling in a course or starting important studies",
    te: "విద్యా ప్రారంభం — కొత్త కోర్సులో చేరడం లేదా ముఖ్యమైన చదువులు ప్రారంభించడం",
    hi: "विद्या आरंभ — नए कोर्स में दाखिला या महत्वपूर्ण पढ़ाई शुरू करना",
    ta: "வித்யா ஆரம்பம் — புதிய படிப்பில் சேருதல் அல்லது முக்கியமான படிப்பு தொடங்குதல்",
    kn: "ವಿದ್ಯಾ ಆರಂಭ — ಹೊಸ ಕೋರ್ಸ್‌ಗೆ ಸೇರುವುದು ಅಥವಾ ಮುಖ್ಯ ಅಧ್ಯಯನ ಪ್ರಾರಂಭ",
    ml: "വിദ്യാ ആരംഭം — പുതിയ കോഴ്‌സിൽ ചേരൽ അല്ലെങ്കിൽ പ്രധാന പഠനം ആരംഭിക്കൽ" },
  { en: "Bhoomi / Gruha Krayam — signing agreement papers to buy land, an apartment, or a house",
    te: "భూమి / గృహ క్రయం — భూమి, ఫ్లాట్ లేదా ఇల్లు కొనుగోలు ఒప్పంద పత్రాలపై సంతకం",
    hi: "भूमि / गृह क्रय — भूमि, फ्लैट या घर खरीदने के अनुबंध पत्रों पर हस्ताक्षर",
    ta: "பூமி / க்ருஹ க்ரயம் — நிலம், ஃபிளாட் அல்லது வீடு வாங்கும் ஒப்பந்த பத்திரங்களில் கையொப்பமிடுதல்",
    kn: "ಭೂಮಿ / ಗೃಹ ಕ್ರಯ — ಭೂಮಿ, ಫ್ಲಾಟ್ ಅಥವಾ ಮನೆ ಖರೀದಿ ಒಪ್ಪಂದ ಪತ್ರಗಳಿಗೆ ಸಹಿ",
    ml: "ഭൂമി / ഗൃഹ ക്രയം — ഭൂമി, ഫ്ലാറ്റ് അല്ലെങ്കിൽ വീട് വാങ്ങുന്നതിനുള്ള കരാർ പത്രങ്ങളിൽ ഒപ്പിടൽ" },
  { en: "Yatra Arambham — starting an important journey, relocation, or pilgrimage",
    te: "యాత్రా ప్రారంభం — ముఖ్యమైన ప్రయాణం, తరలింపు లేదా యాత్ర ప్రారంభించడం",
    hi: "यात्रा आरंभ — महत्वपूर्ण यात्रा, स्थानांतरण या तीर्थयात्रा शुरू करना",
    ta: "யாத்ரா ஆரம்பம் — முக்கியமான பயணம், இடமாற்றம் அல்லது யாத்திரை தொடங்குதல்",
    kn: "ಯಾತ್ರಾ ಆರಂಭ — ಮುಖ್ಯ ಪ್ರಯಾಣ, ಸ್ಥಳಾಂತರ ಅಥವಾ ಯಾತ್ರೆ ಪ್ರಾರಂಭ",
    ml: "യാത്രാ ആരംഭം — പ്രധാന യാത്ര, മാറ്റം അല്ലെങ്കിൽ തീർത്ഥാടനം ആരംഭിക്കൽ" },
  { en: "Dravya Grahana — opening a bank account or making investments/contracts",
    te: "ద్రవ్య గ్రహణం — బ్యాంకు ఖాతా తెరవడం లేదా పెట్టుబడులు/ఒప్పందాలు",
    hi: "द्रव्य ग्रहण — बैंक खाता खोलना या निवेश/अनुबंध करना",
    ta: "த்ரவ்ய க்ரஹணம் — வங்கிக் கணக்கு திறத்தல் அல்லது முதலீடு/ஒப்பந்தங்கள்",
    kn: "ದ್ರವ್ಯ ಗ್ರಹಣ — ಬ್ಯಾಂಕ್ ಖಾತೆ ತೆರೆಯುವುದು ಅಥವಾ ಹೂಡಿಕೆ/ಒಪ್ಪಂದಗಳು",
    ml: "ദ്രവ്യ ഗ്രഹണം — ബാങ്ക് അക്കൗണ്ട് തുറക്കൽ അല്ലെങ്കിൽ നിക്ഷേപം/കരാറുകൾ" },
  { en: "Krayavikrayalu — major purchases or important legal documents",
    te: "క్రయవిక్రయాలు — పెద్ద మొత్తంలో కొనుగోళ్లు లేదా ముఖ్యమైన న్యాయపరమైన పత్రాలు",
    hi: "क्रयविक्रय — बड़ी खरीदारी या महत्वपूर्ण कानूनी दस्तावेज़",
    ta: "க்ரயவிக்ரயங்கள் — பெரிய கொள்முதல் அல்லது முக்கியமான சட்ட ஆவணங்கள்",
    kn: "ಕ್ರಯವಿಕ್ರಯಗಳು — ದೊಡ್ಡ ಖರೀದಿಗಳು ಅಥವಾ ಮುಖ್ಯ ಕಾನೂನು ದಾಖಲೆಗಳು",
    ml: "ക്രയവിക്രയങ്ങൾ — വലിയ വാങ്ങലുകൾ അല്ലെങ്കിൽ പ്രധാന നിയമ രേഖകൾ" },
];

const NOT_SUITABLE_EVENTS = [
  { en: "Vivaham (Marriage) — needs the 7th house completely empty, plus strong Jupiter & Venus placement",
    te: "వివాహం — 7వ ఇల్లు పూర్తిగా ఖాళీగా ఉండాలి, గురు మరియు శుక్రుడు బలంగా ఉండాలి",
    hi: "विवाह — 7वां घर पूरी तरह खाली होना चाहिए, साथ ही गुरु और शुक्र मजबूत स्थिति में होने चाहिए",
    ta: "விவாஹம் (திருமணம்) — 7வது வீடு முழுவதும் காலியாக இருக்க வேண்டும், மேலும் குரு மற்றும் சுக்ரன் வலுவாக இருக்க வேண்டும்",
    kn: "ವಿವಾಹ — 7ನೇ ಮನೆ ಸಂಪೂರ್ಣ ಖಾಲಿ ಇರಬೇಕು, ಜೊತೆಗೆ ಗುರು ಮತ್ತು ಶುಕ್ರ ಬಲವಾಗಿರಬೇಕು",
    ml: "വിവാഹം — 7-ാം ഭാവം പൂർണ്ണമായും ഒഴിഞ്ഞിരിക്കണം, ഒപ്പം ഗുരുവും ശുക്രനും ബലവാനായിരിക്കണം" },
  { en: "Gruhapravesam (Housewarming) — needs a fixed (Sthira) Lagna, and no malefic planets in the 4th house",
    te: "గృహప్రవేశం — స్థిర లగ్నం అవసరం, 4వ ఇంట్లో పాప గ్రహాలు ఉండకూడదు",
    hi: "गृहप्रवेश — स्थिर लग्न आवश्यक है, और चौथे घर में पाप ग्रह नहीं होने चाहिए",
    ta: "கிரகப்ரவேசம் (இல்லம் நுழைதல்) — ஸ்திர லக்னம் தேவை, 4வது வீட்டில் பாப கிரகங்கள் இருக்கக்கூடாது",
    kn: "ಗೃಹಪ್ರವೇಶ — ಸ್ಥಿರ ಲಗ್ನ ಅಗತ್ಯ, 4ನೇ ಮನೆಯಲ್ಲಿ ಪಾಪ ಗ್ರಹಗಳು ಇರಬಾರದು",
    ml: "ഗൃഹപ്രവേശം — സ്ഥിര ലഗ്നം ആവശ്യമാണ്, 4-ാം ഭാവത്തിൽ പാപഗ്രഹങ്ങൾ പാടില്ല" },
  { en: "Upanayanam (Thread Ceremony) — needs the 8th house completely empty",
    te: "ఉపనయనం — 8వ ఇల్లు పూర్తిగా ఖాళీగా ఉండాలి",
    hi: "उपनयनम् (यज्ञोपवीत) — आठवां घर पूरी तरह खाली होना चाहिए",
    ta: "உபநயனம் (பூணூல்) — 8வது வீடு முழுவதும் காலியாக இருக்க வேண்டும்",
    kn: "ಉಪನಯನ — 8ನೇ ಮನೆ ಸಂಪೂರ್ಣ ಖಾಲಿ ಇರಬೇಕು",
    ml: "ഉപനയനം — 8-ാം ഭാവം പൂർണ്ണമായും ഒഴിഞ്ഞിരിക്കണം" },
  { en: "Seemantham / Namakaranam — needs highly specific Tithi-Nakshatra combinations",
    te: "సీమంతం / నామకరణం — చాలా నిర్దిష్టమైన తిథి-నక్షత్ర కలయికలు అవసరం",
    hi: "सीमंतम् / नामकरण — अत्यंत विशिष्ट तिथि-नक्षत्र संयोजन आवश्यक हैं",
    ta: "சீமந்தம் / நாமகரணம் — மிகவும் குறிப்பிட்ட திதி-நக்ஷத்திர சேர்க்கைகள் தேவை",
    kn: "ಸೀಮಂತ / ನಾಮಕರಣ — ಅತ್ಯಂತ ನಿರ್ದಿಷ್ಟ ತಿಥಿ-ನಕ್ಷತ್ರ ಸಂಯೋಜನೆಗಳು ಅಗತ್ಯ",
    ml: "സീമന്തം / നാമകരണം — വളരെ നിർദ്ദിഷ്ട തിഥി-നക്ഷത്ര സംയോജനങ്ങൾ ആവശ്യമാണ്" },
];

const NAKSHATRAS = [
  { en: "Aśvinī", te: "అశ్విని", hi: "अश्विनी", ta: "அஸ்வினி", kn: "ಅಶ್ವಿನಿ", ml: "അശ്വതി" },
  { en: "Bharaṇī", te: "భరణి", hi: "भरणी", ta: "பரணி", kn: "ಭರಣಿ", ml: "ഭരണി" },
  { en: "Kṛttikā", te: "కృత్తిక", hi: "कृत्तिका", ta: "கார்த்திகை", kn: "ಕೃತ್ತಿಕಾ", ml: "കാർത്തിക" },
  { en: "Rohiṇī", te: "రోహిణి", hi: "रोहिणी", ta: "ரோகிணி", kn: "ರೋಹಿಣಿ", ml: "രോഹിണി" },
  { en: "Mṛgaśira", te: "మృగశిర", hi: "मृगशिरा", ta: "மிருகசீரிடம்", kn: "ಮೃಗಶಿರ", ml: "മകയിരം" },
  { en: "Ārdrā", te: "ఆర్ద్ర", hi: "आर्द्रा", ta: "திருவாதிரை", kn: "ಆರ್ದ್ರಾ", ml: "തിരുവാതിര" },
  { en: "Punarvasu", te: "పునర్వసు", hi: "पुनर्वसु", ta: "புனர்பூசம்", kn: "ಪುನರ್ವಸು", ml: "പുണർതം" },
  { en: "Puṣya", te: "పుష్యమి", hi: "पुष्य", ta: "பூசம்", kn: "ಪುಷ್ಯ", ml: "പൂയം" },
  { en: "Āśleṣā", te: "ఆశ్లేష", hi: "आश्लेषा", ta: "ஆயில்யம்", kn: "ಆಶ್ಲೇಷಾ", ml: "ആയില്യം" },
  { en: "Maghā", te: "మఘ", hi: "मघा", ta: "மகம்", kn: "ಮಘಾ", ml: "മകം" },
  { en: "Pūrva Phalgunī", te: "పూర్వ ఫాల్గుణి", hi: "पूर्वाफाल्गुनी", ta: "பூரம்", kn: "ಪೂರ್ವಾಫಲ್ಗುಣಿ", ml: "പൂരം" },
  { en: "Uttara Phalgunī", te: "ఉత్తర ఫాల్గుణి", hi: "उत्तराफाल्गुनी", ta: "உத்திரம்", kn: "ಉತ್ತರಾಫಲ್ಗುಣಿ", ml: "ഉത്രം" },
  { en: "Hasta", te: "హస్త", hi: "हस्त", ta: "அஸ்தம்", kn: "ಹಸ್ತ", ml: "അത്തം" },
  { en: "Chitrā", te: "చిత్ర", hi: "चित्रा", ta: "சித்திரை", kn: "ಚಿತ್ರಾ", ml: "ചിത്ര" },
  { en: "Svāti", te: "స్వాతి", hi: "स्वाति", ta: "சுவாதி", kn: "ಸ್ವಾತಿ", ml: "ചോതി" },
  { en: "Viśākhā", te: "విశాఖ", hi: "विशाखा", ta: "விசாகம்", kn: "ವಿಶಾಖಾ", ml: "വിശാഖം" },
  { en: "Anurādhā", te: "అనూరాధ", hi: "अनुराधा", ta: "அனுஷம்", kn: "ಅನುರಾಧಾ", ml: "അനിഴം" },
  { en: "Jyeṣṭhā", te: "జ్యేష్ఠ", hi: "ज्येष्ठा", ta: "கேட்டை", kn: "ಜ್ಯೇಷ್ಠಾ", ml: "തൃക്കേട്ട" },
  { en: "Mūla", te: "మూల", hi: "मूल", ta: "மூலம்", kn: "ಮೂಲಾ", ml: "മൂലം" },
  { en: "Pūrvāṣāḍha", te: "పూర్వాషాఢ", hi: "पूर्वाषाढ़ा", ta: "பூராடம்", kn: "ಪೂರ್ವಾಷಾಢ", ml: "പൂരാടം" },
  { en: "Uttarāṣāḍha", te: "ఉత్తరాషాఢ", hi: "उत्तराषाढ़ा", ta: "உத்திராடம்", kn: "ಉತ್ತರಾಷಾಢ", ml: "ഉത്രാടം" },
  { en: "Śravaṇa", te: "శ్రవణం", hi: "श्रवण", ta: "திருவோணம்", kn: "ಶ್ರವಣ", ml: "തിരുവോണം" },
  { en: "Dhaniṣṭhā", te: "ధనిష్ఠ", hi: "धनिष्ठा", ta: "அவிட்டம்", kn: "ಧನಿಷ್ಠಾ", ml: "അവിട്ടം" },
  { en: "Śatabhiṣā", te: "శతభిషం", hi: "शतभिषा", ta: "சதயம்", kn: "ಶತಭಿಷಾ", ml: "ചതയം" },
  { en: "Pūrva Bhādrapadā", te: "పూర్వాభాద్ర", hi: "पूर्वाभाद्रपदा", ta: "பூரட்டாதி", kn: "ಪೂರ್ವಾಭಾದ್ರಪದ", ml: "പൂരുരുട്ടാതി" },
  { en: "Uttara Bhādrapadā", te: "ఉత్తరాభాద్ర", hi: "उत्तराभाद्रपदा", ta: "உத்திரட்டாதி", kn: "ಉತ್ತರಾಭಾದ್ರಪದ", ml: "ഉത്തൃട്ടാതി" },
  { en: "Revatī", te: "రేవతి", hi: "रेवती", ta: "ரேவதி", kn: "ರೇವತಿ", ml: "രേവതി" },
];

const RASIS = [
  { en: "Mesha (Aries)", te: "మేషం", hi: "मेष", ta: "மேஷம்", kn: "ಮೇಷ", ml: "മേഷം" },
  { en: "Vrishabha (Taurus)", te: "వృషభం", hi: "वृषभ", ta: "ரிஷபம்", kn: "ವೃಷಭ", ml: "വൃഷഭം" },
  { en: "Mithuna (Gemini)", te: "మిథునం", hi: "मिथुन", ta: "மிதுனம்", kn: "ಮಿಥುನ", ml: "മിഥുനം" },
  { en: "Karka (Cancer)", te: "కర్కాటకం", hi: "कर्क", ta: "கடகம்", kn: "ಕರ್ಕಾಟಕ", ml: "കർക്കടകം" },
  { en: "Simha (Leo)", te: "సింహం", hi: "सिंह", ta: "சிம்மம்", kn: "ಸಿಂಹ", ml: "ചിങ്ങം" },
  { en: "Kanya (Virgo)", te: "కన్య", hi: "कन्या", ta: "கன்னி", kn: "ಕನ್ಯಾ", ml: "കന്നി" },
  { en: "Tula (Libra)", te: "తుల", hi: "तुला", ta: "துலாம்", kn: "ತುಲಾ", ml: "തുലാം" },
  { en: "Vrischika (Scorpio)", te: "వృశ్చికం", hi: "वृश्चिक", ta: "விருச்சிகம்", kn: "ವೃಶ್ಚಿಕ", ml: "വൃശ്ചികം" },
  { en: "Dhanu (Sagittarius)", te: "ధనుస్సు", hi: "धनु", ta: "தனுசு", kn: "ಧನು", ml: "ധനു" },
  { en: "Makara (Capricorn)", te: "మకరం", hi: "मकर", ta: "மகரம்", kn: "ಮಕರ", ml: "മകരം" },
  { en: "Kumbha (Aquarius)", te: "కుంభం", hi: "कुंभ", ta: "கும்பம்", kn: "ಕುಂಭ", ml: "കുംഭം" },
  { en: "Meena (Pisces)", te: "మీనం", hi: "मीन", ta: "மீனம்", kn: "ಮೀನ", ml: "മീനം" },
];

const toISO = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

// Defaults match the backend's own fallback (Hyderabad, IST) — see backend/config/settings.py.
const DEFAULT_LATITUDE = 17.3871;
const DEFAULT_LONGITUDE = 78.4917;
const DEFAULT_TZ_HOURS = 5.5;

export default function MuhurtamChecker() {
  const { lang, t } = useLanguage();
  const [open, setOpen] = useState(false);
  const [nakshatra, setNakshatra] = useState(1);
  const [rasi, setRasi] = useState(1);
  const [system, setSystem] = useState("chandramana");
  const [startDate, setStartDate] = useState(() => toISO(new Date()));
  const [endDate, setEndDate] = useState(() => toISO(new Date(Date.now() + 30 * 86400000)));
  const [latitude, setLatitude] = useState(DEFAULT_LATITUDE);
  const [longitude, setLongitude] = useState(DEFAULT_LONGITUDE);
  const [tzHours, setTzHours] = useState(DEFAULT_TZ_HOURS);
  const [locating, setLocating] = useState(false);
  const [locationError, setLocationError] = useState("");
  const [placeName, setPlaceName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [results, setResults] = useState(null);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [hasSeenDisclaimer, setHasSeenDisclaimer] = useState(false);
  const [pincodeInput, setPincodeInput] = useState("");
  const [mapPickerOpen, setMapPickerOpen] = useState(false);
  const outcomeRef = useRef(null);

  // Bring the outcome (results / empty / error) into view the moment it's
  // ready, instead of leaving the user to scroll down past the form.
  useEffect(() => {
    if ((results || error) && outcomeRef.current) {
      outcomeRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [results, error]);

  // Resolve a human-readable place name for whatever lat/lon is currently
  // set — from a picked city, "use my location", or manual entry — so the
  // user always sees which place the coordinates actually refer to.
  useEffect(() => {
    const nearest = findNearestCity(latitude, longitude);
    if (!nearest) setPlaceName(null);
    else if (nearest.distanceKm < 5) setPlaceName(nearest.name);
    else if (nearest.distanceKm < 75) setPlaceName(`${t("locNear")} ${nearest.name}`);
    else setPlaceName(t("locCustom"));
  }, [latitude, longitude, t]);

  const submitPincode = (e) => {
    e?.preventDefault?.();
    const hit = findByPincode(pincodeInput);
    if (!hit) {
      setLocationError(t("locPincodeNotFound"));
      return;
    }
    setLatitude(hit.lat);
    setLongitude(hit.lon);
    setTzHours(hit.tzOffsetMin / 60);
    setLocationError("");
    setPincodeInput("");
  };

  const confirmMapPick = ({ lat, lon }) => {
    setLatitude(Number(lat.toFixed(4)));
    setLongitude(Number(lon.toFixed(4)));
    setTzHours(-new Date().getTimezoneOffset() / 60);
    setLocationError("");
    setMapPickerOpen(false);
  };

  const useMyLocation = () => {
    setLocationError("");
    if (!navigator.geolocation) {
      setLocationError(t("muhurtamLocationError"));
      return;
    }
    setLocating(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setLatitude(Number(pos.coords.latitude.toFixed(4)));
        setLongitude(Number(pos.coords.longitude.toFixed(4)));
        // Browser's own UTC offset — matches wherever the device's clock/timezone is set,
        // no external lookup involved. JS reports minutes *behind* UTC, hence the negation.
        setTzHours(-new Date().getTimezoneOffset() / 60);
        setLocating(false);
      },
      () => {
        setLocationError(t("muhurtamLocationError"));
        setLocating(false);
      },
      { timeout: 10000 }
    );
  };

  useEffect(() => {
    if (open && !hasSeenDisclaimer) {
      setShowDisclaimer(true);
      setHasSeenDisclaimer(true);
    }
  }, [open, hasSeenDisclaimer]);

  const label = (obj) => (obj ? (obj[lang] || obj.en || "") : "");

  const submit = async (e) => {
    e?.preventDefault?.();
    setLoading(true);
    setError("");
    setResults(null);
    try {
      const data = await checkMuhurtam({
        janma_nakshatra: nakshatra,
        janma_rasi: rasi,
        system,
        start_date: startDate,
        end_date: endDate,
        latitude,
        longitude,
        tz_offset_min: Math.round(tzHours * 60),
      });
      setResults(data.results || []);
    } catch (err) {
      setError(lang === "te" ? "తొలుతలో తప్పు జరిగింది." : "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className="dharma-fab muhurtam-fab"
        data-testid="muhurtam-fab"
        aria-label="Check Muhurtam"
        onClick={() => setOpen((o) => !o)}
        title={t("muhurtamTitle")}
      >
        <svg className="muhurtam-fab-icon" width="52" height="22" viewBox="0 0 34 14" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect x="1" y="1" width="32" height="12" rx="2" fill="#e8d3a0" stroke="#4a0000" strokeWidth="1" />
          <circle cx="5" cy="7" r="1.3" fill="#4a0000" />
          <line x1="9" y1="4" x2="30" y2="4" stroke="#4a0000" strokeWidth="0.8" />
          <line x1="9" y1="7" x2="30" y2="7" stroke="#4a0000" strokeWidth="0.8" />
          <line x1="9" y1="10" x2="30" y2="10" stroke="#4a0000" strokeWidth="0.8" />
        </svg>
        <span className="muhurtam-fab-label">{t("muhurtamTitle")}</span>
      </button>
      {open && (
        <div className="dharma-panel muhurtam-panel" data-testid="muhurtam-panel">
          <div className="dharma-header">
            <div className="dharma-avatar">🗓</div>
            <div>
              <div className="dharma-title">{t("muhurtamTitle")}</div>
              <div className="dharma-sub">{t("muhurtamSub")}</div>
            </div>
            <button
              className="muhurtam-info-btn"
              data-testid="muhurtam-info"
              aria-label="About this checker"
              title={t("muhurtamDisclaimerTitle")}
              onClick={() => setShowDisclaimer(true)}
            >
              ⓘ
            </button>
            <button className="dharma-close" data-testid="muhurtam-close" onClick={() => setOpen(false)}>&times;</button>
          </div>

          {showDisclaimer && (
            <div className="muhurtam-disclaimer-overlay" data-testid="muhurtam-disclaimer">
              <div className="muhurtam-disclaimer-box">
                <div className="muhurtam-disclaimer-title">{t("muhurtamDisclaimerTitle")}</div>

                <div className="muhurtam-disclaimer-heading muhurtam-disclaimer-ok">{t("muhurtamSuitableFor")}</div>
                <ul className="muhurtam-disclaimer-list">
                  {SUITABLE_EVENTS.map((ev, i) => (
                    <li key={i}>✅ {label(ev)}</li>
                  ))}
                </ul>

                <div className="muhurtam-disclaimer-heading muhurtam-disclaimer-warn">{t("muhurtamNotSuitableFor")}</div>
                <ul className="muhurtam-disclaimer-list">
                  {NOT_SUITABLE_EVENTS.map((ev, i) => (
                    <li key={i}>⚠️ {label(ev)}</li>
                  ))}
                </ul>

                <p className="muhurtam-disclaimer-note">{t("muhurtamDisclaimerNote")}</p>

                <button className="dharma-send muhurtam-submit" onClick={() => setShowDisclaimer(false)}>
                  {t("muhurtamGotIt")}
                </button>
              </div>
            </div>
          )}

          <div className="muhurtam-body">
            <div className="muhurtam-inline-note">{t("muhurtamInlineNote")}</div>
            <form className="muhurtam-form" onSubmit={submit}>
              <label className="muhurtam-field">
                {t("muhurtamNakshatra")}
                <select value={nakshatra} onChange={(e) => setNakshatra(Number(e.target.value))}>
                  {NAKSHATRAS.map((n, i) => (
                    <option key={i} value={i + 1}>{label(n)}</option>
                  ))}
                </select>
              </label>

              <label className="muhurtam-field">
                {t("muhurtamRasi")}
                <select value={rasi} onChange={(e) => setRasi(Number(e.target.value))}>
                  {RASIS.map((r, i) => (
                    <option key={i} value={i + 1}>{label(r)}</option>
                  ))}
                </select>
              </label>

              <label className="muhurtam-field">
                {t("muhurtamSystem")}
                <select value={system} onChange={(e) => setSystem(e.target.value)}>
                  <option value="chandramana">{t("muhurtamChandramana")}</option>
                  <option value="souramana">{t("muhurtamSouramana")}</option>
                  <option value="best">{t("muhurtamBest")}</option>
                </select>
              </label>

              <div className="muhurtam-date-row">
                <label className="muhurtam-field">
                  {t("muhurtamStartDate")}
                  <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                </label>
                <label className="muhurtam-field">
                  {t("muhurtamEndDate")}
                  <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                </label>
              </div>

              <button
                type="button"
                className="dharma-send muhurtam-locate-btn"
                onClick={useMyLocation}
                disabled={locating}
              >
                {locating ? t("muhurtamLocating") : t("muhurtamUseLocation")}
              </button>
              <div className="loc-secondary-row">
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength={6}
                  className="muhurtam-city-input"
                  placeholder={t("locPincodePlaceholder")}
                  value={pincodeInput}
                  onChange={(e) => setPincodeInput(e.target.value.replace(/\D/g, ""))}
                />
                <button type="button" className="dharma-send" style={{ width: "auto" }} onClick={submitPincode}>
                  {t("locPincode")}
                </button>
              </div>
              <button
                type="button"
                className="dharma-send muhurtam-locate-btn"
                onClick={() => setMapPickerOpen(true)}
              >
                {t("locPickMap")}
              </button>
              {locationError && <div className="muhurtam-error">{locationError}</div>}
              {placeName && <div className="muhurtam-place-name">📍 {placeName}</div>}
              {mapPickerOpen && (
                <MapPicker
                  initialLat={latitude}
                  initialLon={longitude}
                  onPick={confirmMapPick}
                  onClose={() => setMapPickerOpen(false)}
                  t={t}
                />
              )}

              <div className="muhurtam-date-row">
                <label className="muhurtam-field">
                  {t("muhurtamLatitude")}
                  <input
                    type="number" step="0.0001" min="-90" max="90"
                    value={latitude}
                    onChange={(e) => setLatitude(Number(e.target.value))}
                  />
                </label>
                <label className="muhurtam-field">
                  {t("muhurtamLongitude")}
                  <input
                    type="number" step="0.0001" min="-180" max="180"
                    value={longitude}
                    onChange={(e) => setLongitude(Number(e.target.value))}
                  />
                </label>
              </div>
              <label className="muhurtam-field">
                {t("muhurtamTimezone")}
                <input
                  type="number" step="0.25" min="-12" max="14"
                  value={tzHours}
                  onChange={(e) => setTzHours(Number(e.target.value))}
                />
              </label>

              <button type="submit" className="dharma-send muhurtam-submit" disabled={loading}>
                {loading ? t("muhurtamChecking") : t("muhurtamCheck")}
              </button>
            </form>

            <div ref={outcomeRef}>
            {error && <div className="muhurtam-error">{error}</div>}

            {results && results.length === 0 && (
              <div className="muhurtam-empty">{t("muhurtamNoResults")}</div>
            )}

            {results && results.length > 0 && (
              <div className="muhurtam-results">
                {results.map((r) => (
                  <div key={r.date} className="muhurtam-day-card">
                    <div className="muhurtam-day-title">
                      {r.date} — {label(r.masa)} {label(r.paksha)}, {label(r.tithi)}
                    </div>
                    <div className="muhurtam-day-sub">{label(r.nakshatra)} · {label(r.moon_rasi)}</div>

                    <div className="muhurtam-excluded">
                      <strong>{t("muhurtamExcluded")}:</strong>
                      <div>{t("muhurtamRahuKalam")}: {r.excluded.rahu_kalam}</div>
                      <div>{t("muhurtamDurmuhurtam")}: {r.excluded.durmuhurtam}</div>
                      <div>{t("muhurtamVarjyam")}: {r.excluded.varjyam}</div>
                    </div>

                    <div className="muhurtam-windows">
                      <strong>{t("muhurtamSafeWindows")}:</strong>
                      {r.windows.map((w, i) => (
                        <div key={i} className="muhurtam-window">
                          <span className="muhurtam-lagna">{t("muhurtamLagna")}: {label(w.lagna)}</span>
                          {w.safe_slots.map((s, j) => (
                            <span key={j} className="muhurtam-slot">{s.start} – {s.end}</span>
                          ))}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
